/**
 * This function is used to ensure that I want today's date without time information 00:00:00:00 (all zero).
 * There was an issue where milisecond data can't be zero when I set it via setHours method (0, 0, 0, 0)
 * and the result was something like 00:00:00:00004.
 * @returns Date
 */
function getNowDate() {
  const now = new Date()
  const nowDate = new Date(now.toDateString())

  return nowDate
}

function buildStartDate(dateDiff = 0) {
  const startDate = getNowDate()
  startDate.setDate(startDate.getDate() - dateDiff)

  return startDate
}

function buildEndDate(dateDiff = 0) {
  const endDate = getNowDate()
  endDate.setDate(endDate.getDate() - dateDiff)
  endDate.setHours(23, 59, 59, 999)

  return endDate
}

const dateFilterShortcuts = [
  {
    text: 'Hari Ini',
    onClick: () => {
      return [buildStartDate(), buildEndDate()]
    },
  },
  {
    text: 'Kemarin',
    onClick: () => {
      return [buildStartDate(1), buildEndDate(1)]
    },
  },
  {
    text: '3 Hari Terakhir',
    onClick: () => {
      return [buildStartDate(3), buildEndDate()]
    },
  },
  {
    text: '7 Hari Terakhir',
    onClick: () => {
      return [buildStartDate(7), buildEndDate()]
    },
  },
].map((shortcut) => ({ ...shortcut, value: shortcut.onClick }))

export const tableFilterFields = [
  {
    name: 'transaction_date',
    isShow: true,
    label: '',
    _label: 'Periode Laporan',
    type: 'date-picker',
    datepickerType: 'date',
    valueType: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
    format: 'DD MMM YYYY',
    titleFormat: 'DD MMM YYYY',
    rangeSeparator: ' - ',
    range: true,
    draft: true,
    confirm: true,
    confirmText: 'Terapkan',
    shortcuts: dateFilterShortcuts,
    validation:"required",
    clearable: false
  },
]
